import { BoxProps, VStack } from "@chakra-ui/react";

export interface InvoicePreviewItemListProps extends BoxProps {}

export const InvoicePreviewItemList = (props: InvoicePreviewItemListProps) => {
  return <VStack w="full" spacing={0} alignItems="flex-start" {...props} />;
};
